import React from 'react'
import styled, { css } from 'styled-components'

import { ASSET_URL, ASSET_URL_V2 } from '../config/env'
import { color } from '../styles'
import { Icon } from './Icon'

type Props = {
    path?: string
    fileName?: string
    filePath?: string
    className?: string
    description: string
    disableClick?: boolean
    disableBackground?: boolean
    objectFit?: 'cover' | 'contain'
    onClick?: (event: React.MouseEvent<HTMLDivElement>) => void
}

const generatePreview = (path?: string, filename?: string, filepath?: string): string | null => {
    if ((!path || !filename) && !filepath) {
        return null
    }

    if (filepath.includes('jpg') || filepath.includes('jpg_t')) {
        return `${ASSET_URL_V2}/${filepath}`.replace('jpg_t', 'jpg')
    }

    if (filepath) {
        return `${ASSET_URL}/${filepath}.jpg`
    }

    // ws_store/0012/210301/190139
    const camera = filename.split('_')[2]

    if (!camera) return null

    return `${ASSET_URL}/${path}/${camera}/${filename}.jpg`
}

export const Image = (props: Props): JSX.Element => {
    const {
        path,
        fileName,
        filePath,
        className,
        description,
        disableClick,
        objectFit = 'cover',
        disableBackground,
        onClick,
    } = props

    let src = generatePreview(path, fileName, filePath)
    if (src?.includes('undefined')) {
        src = null
    }

    return (
        <Container
            className={className}
            disabled={disableClick}
            onClick={(e) => {
                if (disableClick) return
                onClick?.(e)
            }}
            disableBackground={Boolean(disableBackground)}
            key={src}
        >
            {src ? (
                <Content alt={description} src={src} objectFit={objectFit} />
            ) : (
                <Icon size={6} iconKey="FileImage" />
            )}
        </Container>
    )
}

const Container = styled.div<{ disabled?: boolean; disableBackground: boolean }>`
    display: flex;
    height: 100%;
    width: 100%;
    align-items: center;
    justify-content: center;
    background-color: ${color.background.app};
    ${(p) => p.disableBackground && 'background-color: transparent;'}
    ${(p) =>
        p.disabled
            ? ''
            : css`
                  cursor: pointer;
              `}
`

const Content = styled.img<{ objectFit: 'cover' | 'contain' }>`
    width: 100%;
    height: 100%;
    object-fit: ${(p) => p.objectFit};
`

Image.Content = Content
Image.Container = Container
